import templateUrl from './breadcrumb.html';

export const breadcrumbComponent = {
	templateUrl,

	bindings: {
		isSidebarOpen: '='
	},

	controller: class Breadcrumb {
		constructor($state, $transitions, $stateParams, BreadcrumbService) {
			'ngInject';
			this.$stateParams = $stateParams;
			this.breadcrumbs = [];
			this.$state = $state;
			this.breadcrumbService = BreadcrumbService;
			this.onStateChangeSuccess.call(this);
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
		}

		onStateChangeSuccess() {
			const state = this.$state.current;
			this.breadcrumbs = state.name !== 'Home' ? this.breadcrumbService.breadcrumbs : [];
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/breadcrumb/breadcrumb.component.js